import { Button } from "@chakra-ui/button";
import { Box, Flex } from "@chakra-ui/layout";
import ModalCentroDeCusto from "components/Features/CentroDeCusto/ModalCentroDeCusto";
import useGetCentrosDeCusto from "core/features/centro-de-custo/hooks/useGetCentrosDeCusto";
import { useEffect, useState } from "react";
import SelectBaseAntd from "../SelectBaseAntd";
import { SelectBaseAntdProps } from "../SelectBaseAntd/index";

export interface SelectCentroDeCustoProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
  isInvalid?: boolean;
  filteredIds?: string[];
}

function SelectCentroDeCusto({
  value,
  onChange,
  isInvalid,
  filteredIds = [],
  ...rest
}: SelectCentroDeCustoProps) {
  const { isLoading, isFetching, data, refetch } = useGetCentrosDeCusto({});
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [search, setSearch] = useState<string>();

  useEffect(() => {
    if (!isOpenModal) {
      setSearch("");
    }
  }, [isOpenModal]);

  return (
    <>
      <ModalCentroDeCusto
        isOpenModal={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        onSuccess={async (id) => {
          onChange(id);

          refetch();

          setIsOpenModal(false);
        }}
      />

      <SelectBaseAntd
        isInvalid={isInvalid}
        loading={isLoading || isFetching}
        disabled={isLoading || isFetching}
        size="large"
        placeholder="Selecione..."
        value={value || null}
        onChange={onChange}
        allowClear={true}
        showArrow
        {...rest}
        showSearch
        searchValue={search}
        onSearch={(v) => {
          if (!isOpenModal) {
            setSearch(v);
          }
        }}
        optionFilterProp="extra"
        options={data?.items
          .filter((item) => !filteredIds.includes(item.id))
          .map((item) => ({
            value: item.id,
            label: (
              <Flex alignItems="center">
                <Flex flex={1} alignItems="center">
                  {item.nome}
                </Flex>
              </Flex>
            ),
          }))}
        notFoundContent={
          !isLoading && !isFetching ? (
            <Box>
              Nada encontrado!!{" "}
              <Button
                leftIcon={<i className="mdi mdi-plus" />}
                size="xs"
                colorScheme="orange"
                onClick={() => setIsOpenModal(true)}
              >
                cadastrar novo
              </Button>
            </Box>
          ) : (
            <Box>Carregando...</Box>
          )
        }
      />
    </>
  );
}

export default SelectCentroDeCusto;
